import { render } from "./EmployersView.vue?vue&type=template&id=0df05b22&scoped=true"
import script from "./EmployersView.vue?vue&type=script&lang=js"
export * from "./EmployersView.vue?vue&type=script&lang=js"

import "./EmployersView.vue?vue&type=style&index=0&id=0df05b22&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0df05b22"]])

export default __exports__